<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <h1 class="ts-uppercase ts-font-semibold ts-text-lg">
          {{ $t('studentEnrollment.forwardClass') }}
        </h1>

        <div class="ts-border-2 ts-border-dashed ts-rounded-md ts-mt-4 ts-p-4">
          <div class="row ts-space-y-2">
            <div class="col-md-12">
              <label class="col-form-label col-md-12 required" style="margin-left: -12px;">{{
                $t('studentEnrollment.class') }}</label>
              <a-radio-group v-model="acStatusId" @change="onStatusChange" size="small">
                <a-radio-button :value="1">
                  {{ $t('studentEnrollment.current') }}
                </a-radio-button>
                <a-radio-button :value="2">
                  {{ $t('studentEnrollment.history') }}
                </a-radio-button>
              </a-radio-group>
              <treeselect :multiple="false" :options="class_list" :placeholder="$t('select')"
                v-model.number="model.old_class_id" @select="value => (acp_id = value.acp_id)" />
              <div class="validate" v-if="errors.has('old_class_id')">
                {{ errors.first('old_class_id') }}
              </div>
            </div>
            <div class="col-md-12">
              <label class="col-form-label required col-md-12" style="margin-left: -12px;">{{
                $t('studentEnrollment.newClass') }}</label>
              <a-radio-group v-model="model.ac_status_id" @change="onStatusNewChange" size="small">
                <a-radio-button :value="1">
                  {{ $t('studentEnrollment.current') }}
                </a-radio-button>
                <a-radio-button :value="3">
                  {{ $t('studentEnrollment.next') }}
                </a-radio-button>
              </a-radio-group>
              <treeselect :multiple="false" :options="forwardClass" :disabled="!acp_id ? true : false"
                :placeholder="$t('select')" v-model.number="model.new_class_id" />
              <small><i>Take only class operation in next status and the same grade
                  as current class and next class.</i></small>
              <div class="validate" v-if="errors.has('new_class_id')">
                {{ errors.first('new_class_id') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-4">
          <div class="col-md-12">
            <div id="container-table">
              <ts-table :columns="columns" :records="resources" :loading="loading" :showCheckbox="true"
                @check-items="checkItem">
                <template v-slot="{ record }">
                  <td>{{ record.student_profile.card_number }}</td>
                  <td>{{ record.student_profile.full_name_en }}</td>
                  <td>{{ record.student_profile.gender }}</td>
                  <td>{{ record.student_profile.phone }}</td>
                </template>
              </ts-table>
            </div>
            <div class="validate" v-if="errors.has('student_list')">
              {{ errors.first('student_list') }}
            </div>
          </div>
        </div>
        <div class="row ts-mt-4">
          <div class="col-md-12 text-right">
            <ts-button @click="$emit('close')" class="mr-2">{{
              $t('cancel')
            }}</ts-button>
            <ts-button color="primary" outline class="mr-2" :waiting="waiting_new"
              @click.prevent="storeStudentForwardNew">{{
                $t('save_add_new') }}</ts-button>
            <ts-button color="primary" :waiting="waiting" @click.prevent="storeStudentForward">{{ $t('save')
            }}</ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'classForward',
  data() {
    return {
      model: {
        old_class_id: null,
        new_class_id: null,
        student_list: [],
        ac_status_id: 3,
        trans_type: 1
      },
      resources: [],
      loading: false,
      forwardClass: null,
      class_list: [],
      acp_id: 0,
      waiting: false,
      waiting_new: false,
      errors: new Errors()
    }
  },
  computed: {
    columns() {
      return [
        { name: this.$t('studentEnrollment.studentCard') },
        { name: this.$t('studentEnrollment.studentName') },
        { name: this.$t('studentEnrollment.gender') },
        { name: this.$t('studentEnrollment.phone') }
      ]
    },
    acStatusId: {
      get() {
        return this.$store.state.studentEnrollment.ac_status_id
      },
      set(newValue) {
        this.$store.commit('studentEnrollment/SET_AC_STATUS', newValue)
      }
    }
  },
  created() {
    this.fetchClass()
  },
  methods: {
    ...mapActions('studentEnrollment', [
      'getClassOperation',
      'fetchStudentEnrollByClass'
    ]),
    filterStudent() {
      if (this.model.old_class_id != undefined) {
        this.loading = true
        this.fetchStudentEnrollByClass({
          page: -1,
          filter: {
            class_id: this.model.old_class_id
          }
        })
          .then(response => {
            this.resources = response.data
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.acp_id = 0
      }
    },
    checkItem(items) {
      this.model.student_list = items.map(el => el.student_id)
    },
    fetchClass() {
      this.loading = true
      this.getClassOperation({
        perPage: -1
      })
        .then(response => {
          this.class_list = response.data.map(el => ({
            acp_id: el.acp_id,
            id: el.class_id,
            label: `${el.class_name} | ${el.teacher_name}  
								| ${el.study_time}
								| ${el.ac_status_description}
                | ${el.ac_year}
								| ${el.term_name}`
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    storeStudentForward() {
      this.waiting = true
      this.$store
        .dispatch('studentEnrollment/storeStudentForward', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    storeStudentForwardNew() {
      this.waiting_new = true
      this.$store
        .dispatch('studentEnrollment/storeStudentForward', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    loadForwardClass() {
      this.options = null
      if (this.acp_id) {
        this.loading = true
        this.getClassOperation({
          filter: {
            acp_id: this.acp_id,
            ac_status_id: this.model.ac_status_id
          },
          trans_type: this.model.trans_type,
          old_class_id: this.model.old_class_id,
          perPage: -1
        })
          .then(response => {
            this.forwardClass = response.data.map(el => ({
              id: el.class_id,
              label: `${el.class_name} | ${el.teacher_name}  
								| ${el.study_time}
								| ${el.ac_status_description}
                | ${el.ac_year}
								| ${el.term_name}`
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => (this.loading = false))
      }
    },
    onStatusChange() {
      this.class_list = []
      this.model.old_class_id = null
      this.fetchClass()
    },
    onStatusNewChange() {
      this.forwardClass = []
      this.model.new_class_id = null
      this.loadForwardClass()
    },
    clearInput() {
      this.model.old_class_id = null
      this.model.new_class_id = null
      this.model.student_list = []
      // this.model = {
      //   old_class_id: null,
      //   new_class_id: null,
      //   student_list: []
      // }
    }
  },
  watch: {
    'model.old_class_id': function () {
      this.model.student_list = []
      this.model.new_class_id = null
      this.resources = []
      this.filterStudent()
      this.loadForwardClass()
    }
  }
}
</script>
